<template>
  <div class="wapper">
    <div class="title" style="display:block;">方案内容</div>
    <div class="extra-table-container">
      <div>
        <div class="extra-table-title">折算业绩与提成方案表</div>
      </div>
      <div class="extra-table-wapper">
        <div class="ext-table-one" v-if="info.optionList && info.optionList.conditions.length > 0">
          <el-table :data="info.optionList.conditions" size="mini" :border="true" empty-text>
            <el-table-column :label="`${info.optionList.fieldName}（由运营在创建模版时选择）`" prop="optionName" show-overflow-tooltip width="210" :render-header="renderHeader"></el-table-column>
            <el-table-column width="80" label="销售提成" prop="saleRoyalty">
              <template slot-scope="scope">
                <span class="color-red">{{ scope.row.saleRoyalty }}%</span>
              </template>
            </el-table-column>
            <el-table-column width="80" label="经理提成" prop="managerRoyalty">
              <template slot-scope="scope">
                <span>{{ scope.row.managerRoyalty }}%</span>
              </template>
            </el-table-column>
            <el-table-column width="80" label="总监提成" prop="directorRoyalty">
              <template slot-scope="scope">
                <span>{{ scope.row.directorRoyalty }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-two" v-if="info.conversionValidityList && info.conversionValidityList.length > 0">
          <div class="new-table-title">有效期折算业绩系数</div>
          <el-table :data="info.conversionValidityList" size="mini" empty-text :border="true">
            <el-table-column label="有效期区间" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.minMonth }}个月(含)</span> ~
                <span>{{ scope.row.maxMonth }}个月(不含)</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期折算业绩系数" width="130" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="coefficient-color">{{ scope.row.coefficient }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 适用应用规则 start -->
        <div class="table-thr" v-if="info.flagPaltform==1">
          <div class="new-table-title">适用应用规则折算业绩系数</div>
          <div class="performanceRule-table" >
            <p class="cell">{{ info.platformMatchType == 1 ? '如果满足以下任意条件之一' : '如果同时满足以下所有条件' }}</p>
            <p class="condition" v-for="item in info.performanceRuleList" :key="item.id">条件：应用规则{{ item.relationType ==
              '1' ?
              '包含' : '不包含' }} {{ item.platformName }}-{{ item.appRuleName }}</p>
            <p class="cell">那么适用应用规则折算业绩系数=</p>
            <p class="performanceRuleFactor">{{ info.performanceRuleFactor }}%</p>
          </div>
        </div>
        <div class="table-five" v-if="info.budgetConversionFactor != null">
          <div class="new-table-title">预算范围折算业绩系数</div>
          <div class="budgetConversionFactor color-blue">{{ info.budgetConversionFactor }}%</div>
        </div>
        <div class="table-four" v-if="info.vipCouponList && info.vipCouponList.length > 0">
          <div class="new-table-title">VIP劵包折算业绩系数</div>
          <el-table :data="info.vipCouponList" size="mini" :border="true" empty-text>
            <el-table-column label="VIP劵包" width="70" prop="name" show-overflow-tooltip></el-table-column>
            <el-table-column class="vip-color" prop="desc" label="有效期折算业绩系数">
              <template slot-scope="scope">
                <span class="vip-color">{{ scope.row.desc }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="formula-wapper">
      <div class="formula-title">公式</div>
      <!-- 条件选项公式 -->
      <div class="formula-list">
        <p class="formula-item">
          <span class="label">销售的提成金额 = </span>
          <span>销售金额</span> ×
          <span class="color-red">运营所选的条件对应的销售提成</span> ×
          <span class="color-purple">有效期折算业绩系数</span> ×
          <span class="EC808D">适用应用规则折算业绩系数</span> ×
          <span class="color-yellow">销售下单选中的VIP券包折算业绩系数</span>
        </p>
        <p class="formula-item">
          <span class="label">经理的提成金额 = </span>
          <span>销售金额</span> ×
          <span>运营所选的条件对应的经理提成</span> ×
          <span class="color-purple">有效期折算业绩系数</span> ×
          <span class="EC808D">适用应用规则折算业绩系数</span> ×
          <span class="color-yellow">销售下单选中的VIP券包折算业绩系数</span>
        </p>
        <p class="formula-item">
          <span class="label">总监的提成金额 = </span>
          <span>销售金额</span> ×
          <span>运营所选的条件对应的总监提成</span> ×
          <span class="color-purple">有效期折算业绩系数</span> ×
          <span class="EC808D">适用应用规则折算业绩系数</span> ×
          <span class="color-yellow">销售下单选中的VIP券包折算业绩系数</span>
        </p>
        <p class="formula-item">
          <span class="label">折算业绩 = </span>
          <span>销售金额</span> ×
          <span class="color-purple">有效期折算业绩系数</span> ×
          <span class="EC808D">适用应用规则折算业绩系数</span> ×
          <span class="color-blue">预算范围折算业绩系数</span> ×
          <span class="color-yellow">销售下单选中的VIP券包折算业绩系数</span>
        </p>
      </div>
      <p class="formula-note">注意：如果方案表中未出现公式中的项，则该项不参与计算</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['info'],
  methods: {
    renderHeader(h, { column, $index }) {
      return h('span', {
        style: {
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          lineHeight: '1.2'
        }
      }, column.label)
    }
  },
}
</script>

<style>
.extra-table-container{
  /* width: 1200px; */
  display: inline-block;
  border: 0.5px solid #d6dbe5;
}
.extra-table-wapper {
  max-width: 1200px;
  display: flex;
  overflow: auto;
}
.ext-table-one {
  border-right: 0.5px solid #d6dbe5;
}
.extra-table-title{
  width: 100%;
  background-color: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
}
</style>
